<template>
  <div class="modal-overlay" v-if="visible" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ artist }} - {{ stage }}舞台</h2>
        <button class="close-button" @click="close">×</button>
      </div>
      
      <div class="stats-container">
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-label">演出时间</div>
            <div class="stat-value">{{ startTime }} - {{ endTime }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">演出时长</div>
            <div class="stat-value">{{ duration }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">最高观众数</div>
            <div class="stat-value">{{ peakCount }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">平均观众数</div>
            <div class="stat-value">{{ avgCount }}</div>
          </div>
        </div>
      </div>

      <div class="chart-container">
        <audience-chart
          :artist="artist"
          :date="date"
          :stage="stage"
          height="300px"
          @chart-time-click="handleChartTimeClick"
        />
      </div>

      <!-- 添加时间点击弹窗 -->
      <div v-if="showTimePopup" class="time-popup">
        <div class="time-popup-content">
          <div class="time-popup-header">
            <h3>选中的时间点</h3>
            <button class="close-button" @click="showTimePopup = false">×</button>
          </div>
          <div class="time-popup-body">
            <div class="time-info">
              <span class="time-label">时间：</span>
              <span class="time-value">{{ formatTime(selectedTime) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 新增区域信息显示部分 -->
      <div class="area-info-container">
        <h3>区域信息</h3>
        <div v-if="areasLoading" class="loading-state">
          <span>加载中...</span>
        </div>
        <div v-else-if="areasError" class="error-state">
          <span>{{ areasError }}</span>
        </div>
        <div v-else-if="areas.length === 0" class="empty-state">
          <span>没有区域信息</span>
        </div>
        <div v-if="artistAreaData !== null" class="chart-container">
          <ArtistArea-chart
            :artist="artist"
            :date="date"
            :data="artistAreaData"
            :stage="stage"
            height="300px"
            @chart-time-click="handleChartTimeClick"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AudienceChart from './AudienceChart.vue';
import ArtistAreaChart from './ArtistAreaChart.vue';
import api from '../api/config';
export default {
  name: 'ArtistStatsModal',
  components: {
    AudienceChart,ArtistAreaChart
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    artist: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    stage: {
      type: String,
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    peakCount: {
      type: Number,
      required: true,
    },
    avgCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentTime: 0,
      timeData: [],
      loading: false,
      error: null,
      areas: [],
      areasLoading: false,
      areasError: null,
      showTimePopup: false,
      selectedTime: null,
      artistAreaData: null,
      selected: ''
    };
  },
  computed: {
    formattedCurrentTime() {
      if (!this.timeData.length || this.currentTime >= this.timeData.length) {
        return '无数据';
      }
      const time = new Date(this.timeData[this.currentTime].time);
      return time.toLocaleTimeString('zh-CN', { 
        hour: '2-digit', 
        minute: '2-digit',
        second: '2-digit'
      });
    },
    currentImageUrl() {
      if (!this.timeData.length || this.currentTime >= this.timeData.length) return '';
      const timeStr = this.timeData[this.currentTime].time.replace(/[:.]/g, '-');
      return `/api/stage-images/${this.stage}/${this.date}/${timeStr}`;
    },
    dropdownOptions() {
      return this.areas.map(item => ({
        label: item.area,
        value: item.area
      }))
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    changeEchart(data) {
      this.artistAreaData = data
    },
    handleChange() {
      this.artistAreaData = JSON.parse(JSON.stringify(this.areas))
    },
    handleTimeChange(event) {
      console.log('Time changed:', event.target.value);
      const value = parseInt(event.target.value);
      if (!isNaN(value) && value >= 0 && value < this.timeData.length) {
        this.currentTime = value;
        this.fetchStageImage();
      }
    },
    async fetchTimeData() {
      try {
        this.loading = true;
        this.error = null;
        console.log('Fetching data for:', this.artist, this.date, this.stage);
        
        // 生成测试数据
        const mockData = [];
        const startTime = new Date(`${this.date} ${this.startTime}`);
        const endTime = new Date(`${this.date} ${this.endTime}`);
        const interval = 1 * 60 * 1000; // 1分钟间隔
        
        let current = new Date(startTime);
        while (current <= endTime) {
          mockData.push({
            time: current.toISOString(),
            audience_count: Math.floor(Math.random() * 1000) + 500
          });
          current = new Date(current.getTime() + interval);
        }
        
        console.log('Generated mock data:', mockData.length, 'items');
        this.timeData = mockData;
        this.currentTime = 0;
        this.loading = false;
        
        // 初始化后加载第一张图片
        if (mockData.length > 0) {
          this.fetchStageImage();
        }
      } catch (error) {
        console.error('Error fetching time data:', error);
        this.error = '加载时间数据失败';
        this.loading = false;
      }
    },
    async fetchStageImage() {
      // 这里可以添加加载状态
      if (!this.timeData.length || this.currentTime >= this.timeData.length) {
        this.error = '无法加载图片: 无效的时间索引';
        return;
      }
      
      console.log('Fetching image for time:', this.formattedCurrentTime);
      
      // 这里可以添加实际的图片加载逻辑
      // 例如：如果需要从服务器获取图片，可以在这里发起请求
      // 目前我们只是使用computed属性中的currentImageUrl
    },
    // 新增获取区域信息的方法
    async fetchAreasInfo() {
      try {
        this.areasLoading = true;
        this.areasError = null;
        console.log('Fetching areas info for stage:', this.stage, 'on date:', this.date);
        
        // 使用 api 实例发送请求
        const response = await api.get(`/stage-areas/${this.stage}/${this.date}/${this.artist}`);
        
        this.areas = response.data;
        this.selected = JSON.parse(JSON.stringify(this.areas[0].area))
        this.artistAreaData = JSON.parse(JSON.stringify(this.areas))
        console.log(JSON.parse(JSON.stringify(this.areas)), 'JSON.parse(JSON.stringify(this.areas))')
        console.log('Fetched areas data:', this.areas);
        
      } catch (error) {
        console.error('Error fetching areas data:', error);
        this.areasError = '加载区域信息失败';
      } finally {
        this.areasLoading = false;
      }
    },
    handleChartTimeClick(timestamp) {
      console.log('Chart time clicked:', timestamp);
      this.selectedTime = timestamp;
      this.showTimePopup = true;
    },
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          console.log('Modal opened, fetching data...');
          this.fetchTimeData();
          this.fetchAreasInfo(); // 新增：加载区域信息
        }
      }
    },
    currentTime(newVal) {
      console.log('Current time updated:', newVal);
    },
    selected(val) {
      this.handleChange(val)
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #666;
}

.stats-container {
  margin-bottom: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.stat-item {
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.chart-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
  height: 300px;
  margin-bottom: 24px;
}

/* 新增区域图片查看器样式 */
.area-viewer {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.area-viewer h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  color: #333;
}

.time-control {
  margin-bottom: 16px;
  padding: 0 10px;
}

.time-display {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.time-slider {
  width: 100%;
  height: 20px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.time-slider::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  background: #e8e8e8;
  border-radius: 2px;
  cursor: pointer;
}

.time-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: #1890ff;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -6px;
}

.time-slider::-moz-range-track {
  width: 100%;
  height: 4px;
  background: #e8e8e8;
  border-radius: 2px;
  cursor: pointer;
}

.time-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #1890ff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
}

.time-slider:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.time-slider:focus {
  outline: none;
}

.time-slider:hover::-webkit-slider-thumb {
  background: #40a9ff;
}

.time-slider:hover::-moz-range-thumb {
  background: #40a9ff;
}

.image-container {
  position: relative;
  width: 100%;
  height: 400px;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.stage-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.loading-state,
.error-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #666;
  padding: 20px;
}

.error-state {
  color: #ff4d4f;
}

.empty-state {
  color: #999;
}

/* 新增区域信息样式 */
.area-info-container {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.area-info-container h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  color: #333;
}

.areas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.area-item {
  padding: 16px;
  background: #f8f8f8;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.area-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.area-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.area-capacity {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.area-current {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1890ff;
}

.area-fill-rate {
  font-size: 20px;
  font-weight: 600;
  color: #52c41a;
  background: rgba(82, 196, 26, 0.1);
  border-radius: 20px;
  padding: 4px 12px;
  display: inline-block;
  margin-top: 5px;
}

.area-fill-rate.high {
  color: #fa8c16;
  background: rgba(250, 140, 22, 0.1);
}

.area-fill-rate.critical {
  color: #f5222d;
  background: rgba(245, 34, 45, 0.1);
}

@media (max-width: 768px) {
  .modal-content {
    padding: 16px;
    width: 95%;
  }

  .stats-grid {
    grid-template-columns: 1fr 1fr;
  }

  .areas-grid {
    grid-template-columns: 1fr;
  }

  .image-container {
    height: 300px;
  }
}

.time-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1100;
  min-width: 300px;
}

.time-popup-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.time-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 12px;
}

.time-popup-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.time-popup-body {
  padding: 8px 0;
}

.time-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.time-label {
  color: #666;
  font-size: 14px;
}

.time-value {
  font-size: 16px;
  font-weight: 600;
  color: #1890ff;
}
</style> 